import React from 'react'
import IssuerRemoteOptionsSelectField from '../../common/IssuerRemoteOptionsSelectField'

type Props = {
  handleChange: (field: string, value: string) => void,
  values: {
    [key: string]: string
  }
}

const IssuersFields: React.FC<Props> = ({ handleChange, values }) => {
  return (
    <IssuerRemoteOptionsSelectField
      handleChange={handleChange}
      name="issuers"
      recordValue="issuer_id"
      value={values.issuers}
      multi
    />
  )
}

export default IssuersFields
